import { render, staticRenderFns } from "./PageContainernoMenu.vue?vue&type=template&id=2f8979ba&"
import script from "./PageContainernoMenu.vue?vue&type=script&lang=js&"
export * from "./PageContainernoMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports